<div class="dialog-container">
  <div class="dialog-header flex_sb">
    <div class="dialog-header-title">
      {{
        data.type == 'close-cashier'
          ? ('REPORTS.CLOSE_CASH' | fallbackTranslate)
          : ('REPORTS.OPEN_CASH' | fallbackTranslate)
      }}
      <div
        class="fs-16 fw-400 clr-333"
        *ngIf="billingCounterName"
        [innerHTML]="billingCounterInfo"
      ></div>
    </div>
    <div class="dialog-header-cross flex-center" (click)="cancel_clicked()">
      <img [src]="images.CROSS" class="img-20" alt="close" />
    </div>
  </div>
  <div class="dialog-body flex">
    <div class="dialog-form wd-100 flex-1">
      <div class="fs-16 fw-600 clr-333 m-l-16 m-t-16">
        {{ now | date : 'dd/MM/yyyy, hh:mm a' }}
      </div>
      <form [formGroup]="cashCollectForm">
        <div class="form-container">
          <!-- name field -->
          <div class="form-input-container">
            <label>{{ 'REPORTS.STAFF_NAME' | fallbackTranslate }}</label>
            <input
              type="text"
              [placeholder]="'REPORTS.ENTER_HERE' | fallbackTranslate"
              class="input-name-class m-t-4"
              autocomplete="off"
              formControlName="staff_name"
              [ngClass]="{
                'is-invalid':
                  (cashCollectForm.get('staff_name').errors &&
                    cashCollectForm.get('staff_name').touched) ||
                  (cashCollectForm.get('staff_name').touched &&
                    cashCollectForm.get('staff_name').hasError('name'))
              }"
            />
            <div class="error-field">
              <div
                class="alert-text"
                *ngIf="
                  cashCollectForm.get('staff_name').hasError('required') &&
                  cashCollectForm.get('staff_name').touched
                "
              >
                {{ 'REPORTS.REQ' | fallbackTranslate }}
              </div>
            </div>
          </div>
          <div class="">
            <div class="form-input-container">
              <label>{{ 'REPORTS.SELECT_REASON' | fallbackTranslate }}</label>
              <mat-radio-group
                aria-labelledby="example-radio-group-label"
                class="example-radio-group m-t-4"
                [(ngModel)]="selectedOption"
                [ngModelOptions]="{ standalone: true }"
              >
                <span
                  class="example-list-section c-pointer"
                  *ngFor="let item of reasons"
                  (click)="setRadio(item.id)"
                  [ngClass]="
                    selectedOption == item.id ? 'radio-selected-div' : null
                  "
                >
                  <mat-radio-button
                    class="example-radio-button"
                    [value]="item.id"
                  >
                    {{ item.name }}
                  </mat-radio-button>
                </span>
                <span
                  class="example-list-section c-pointer"
                  (click)="setRadio('custom')"
                  [ngClass]="
                    selectedOption == 'custom' ? 'radio-selected-div' : null
                  "
                >
                  <mat-radio-button
                    class="example-radio-button wd-100"
                    value="custom"
                  >
                    <input
                      [ngClass]="
                        selectedOption == 'custom'
                          ? 'custom-reason-input-active'
                          : null
                      "
                      class="custom-reason-input"
                      type="text"
                      name="reason"
                      id="reason"
                      placeholder="{{
                        'REPORTS.ENTER_A_REASON' | fallbackTranslate
                      }}"
                      [(ngModel)]="reason_text"
                      [ngModelOptions]="{ standalone: true }"
                    />
                  </mat-radio-button>
                </span>
              </mat-radio-group>
            </div>
            <div class="form-input-container">
              <label>
                {{ 'REPORTS.ENTER_AMOUNT_IN_RM' | fallbackTranslate }}
                {{ Currency }})
              </label>
              <nz-input-group [nzAddOnBefore]="Currency" class="m-t-4">
                <input
                  #floatcount
                  formatInputNumber
                  type="text"
                  placeholder="{{ 'REPORTS.ENTER_HERE' | fallbackTranslate }}"
                  class="input-number-class"
                  autocomplete="off"
                  formControlName="amount"
                  (keypress)="inputchanges($event)"
                  (keydown)="keydownChanges($event)"
                  (ngModelChange)="validate($event)"
                  [ngClass]="{
                    'is-invalid':
                      (cashCollectForm.get('amount').errors &&
                        cashCollectForm.get('amount').touched) ||
                      (cashCollectForm.get('amount').touched &&
                        cashCollectForm.get('amount').hasError('name'))
                  }"
                />
              </nz-input-group>
              <div class="error-field">
                <div
                  class="alert-text"
                  *ngIf="
                    cashCollectForm.get('amount').hasError('required') &&
                    cashCollectForm.get('amount').touched
                  "
                >
                  {{ 'REPORTS.REQ' | fallbackTranslate }}
                </div>
                <div
              class="alert-text"
              *ngIf="
                  cashCollectForm.get('amount')?.invalid && cashCollectForm.get('amount')?.value
                  "
              >
              {{ 'OPEN_CASH_DRAWER.ENTER_VALID_AMOUNT' | fallbackTranslate }}
              </div>
              </div>
              <div class="cashcount-switch flex_sb">
                <label>
                  {{ 'REPORTS.SWITCH_TO_CASH_COUNTING' | fallbackTranslate }}
                </label>
                <mat-slide-toggle
                  class="toggle_class pl-10"
                  (change)="cashCountToggleChange($event)"
                  [(ngModel)]="cashCountStatus"
                  [ngModelOptions]="{ standalone: true }"
                ></mat-slide-toggle>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div
      class="cash-count-container flex-1"
      style="transition: all 1s ease-in-out"
      *ngIf="cashCountStatus"
    >
      <div class="m-b-16">
        <div class="fs-16 fw-600 clr-333">
          {{ 'REPORTS.CASH_FLOAT_COUNT' | fallbackTranslate }}
        </div>
        <div class="fs-14 fw-400 clr-666">
          {{ 'REPORTS.SELECT_THE_AMOUNT_OF_FLOAT_MONEY' | fallbackTranslate }}
        </div>
      </div>
      <div class="flex_sb float-count-container">
        <div class="float-counter" *ngFor="let denomination of denominations">
          <div class="float-digit">
            <span class="float-symbol">{{ Currency }}</span>
            {{ format.formatNo(denomination) }}
          </div>

          <nz-button-group
            nzSize="large"
            *ngIf="buttonStatus[denomination].active"
          >
            <button
              nz-button
              nzType="default"
              (click)="decrement(denomination)"
              [disabled]="buttonStatus[denomination].counter === 0"
            >
              <i class="fa fa-minus"></i>
            </button>
            <input
              class="editable-button-input"
              type="number"
              (blur)="onBlur($event.target.value, denomination)"
              (keypress)="isNumberKey($event)"
              [(ngModel)]="buttonStatus[denomination].counter"
              (ngModelChange)="onValueChange($event, denomination)"
            />

            <button
              nz-button
              nzType="default"
              (click)="increment(denomination)"
            >
              <i class="fa fa-plus"></i>
            </button>
          </nz-button-group>
        </div>
      </div>
    </div>
  </div>
  <div class="footer">
    <div *ngIf="cashCountStatus" class="mpos-float-amt flex_sb fs-16 clr-333 m-b-12">
      <div class="fw-400"> {{'REPORTS.FLOAT_AMOUNT' | fallbackTranslate}} </div>
      <div class="fw-700">{{Currency}} {{ cashCollectForm?.get('amount')?.value || 0 }}  </div>
    </div>
    <button
      nz-button
      nzSize="large"
      nzType="primary"
      [nzLoading]="isLoading"
      class="success-btn"
      (click)="save_clicked()"
      [disabled]="btnDisabled"
    >
      {{ 'REPORTS.DONE' | fallbackTranslate }}
    </button>
  </div>
</div>
